import React, { useState } from "react";
import * as Yup from "yup";

const useValidate = () => {
  const [validateError, setValidateError] = useState({});
  let schema = "";

  const validate = async (obj, values) => {
    let schema = "";
    if (obj.is_required && obj.attribute_type === "text") {
      schema = Yup.lazy((values) => {
        return Yup.object().shape({
          [obj.field]: Yup.string()
            .max(10, "maximum 10 character")
            .required("This field is required"),
        });
      });

      schema
        .validate(values, { abortEarly: false })
        .then(function () {
          // Success
          setValidateError({ isValid: true, message: "" });
        })
        .catch(function (err) {
          err.inner.forEach((er) => {
            setValidateError({ isValid: false, message: er.message });
          });
        });
    } else if (obj.is_required && obj.attribute_type === "email") {
      schema = Yup.lazy((values) =>
        Yup.object().shape({
          [obj.field]: Yup.string()
            .required("This field is required")
            .email("Email is not valid"),
        })
      );

      schema
        .validate(values, { abortEarly: false })
        .then(function () {
          // Success
          setValidateError({ isValid: true, message: "" });
        })
        .catch(function (err) {
          err.inner.forEach((er) => {
            setValidateError({ isValid: false, message: er.message });
          });
        });
    } else if (obj.attribute_type === "number") {
      if (obj.is_required) {
        schema = Yup.lazy((values) => {
          return Yup.object().shape({
            [obj.field]: Yup.number()
              .required("This field is required")
              .transform((value) => (isNaN(value) ? 0 : value))
              .min(0, "must greater or equal to zero"),
          });
        });

        schema
          .validate(values, { abortEarly: false })
          .then(function () {
            // Success
            setValidateError({ isValid: true, message: "" });
          })
          .catch(function (err) {
            err.inner.forEach((er) => {
              setValidateError({ isValid: false, message: er.message });
            });
          });
      } else {
        schema = Yup.lazy((values) =>
          Yup.object().shape({
            [obj.field]: Yup.number()
              .transform((value) => (isNaN(value) ? 0 : value))
              .min(0, "must greater or equal to zero"),
          })
        );

        schema
          .validate(values, { abortEarly: false })
          .then(function () {
            // Success
            setValidateError({ isValid: true, message: "" });
          })
          .catch(function (err) {
            err.inner.forEach((er) => {
              setValidateError({ isValid: false, message: er.message });
            });
          });
      }
    } else if (obj.is_required && obj.attribute_type === "tel") {
      const phoneRegExp =
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
      schema = Yup.lazy((values) =>
        Yup.object().shape({
          [obj.field]: Yup.string()
            .matches(phoneRegExp, "Phone number is not valid")
            .max(10, "Phone no is not valid")
            .required("This field is required"),
        })
      );

      schema
        .validate(values, { abortEarly: false })
        .then(function () {
          // Success
          setValidateError({ isValid: true, message: "" });
        })
        .catch(function (err) {
          err.inner.forEach((er) => {
            setValidateError({ isValid: false, message: er.message });
          });
        });
    } else {
      return;
    }
  };
  return { validateError, schema, validate };
};

export default useValidate;
